module.exports = __webpack_public_path__ + "static/media/logo.e2dcb3ff.png";